
import { jsPDF } from "jspdf";

  export async function addImageProcess(srcImg): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.src = srcImg;
      img.onload = () => resolve(img);
      img.onerror = reject;
    });
  }

  // A4 page turned the way the picture is: wide shots such as the
  // dermatoscope frames get a landscape page, scans stay portrait.
  const orientationOf = (image: HTMLImageElement) =>
    image.width > image.height ? "landscape" : "portrait"

  // White border kept around the picture on every side, in mm
  const PAGE_MARGIN = 5

  export async function generatePdf(imageUrls) {
    const images: HTMLImageElement[] = []
    for (const url of imageUrls) {
      images.push(await addImageProcess(url))
    }
    if (!images.length) return new jsPDF()

    const doc = new jsPDF({ orientation: orientationOf(images[0]) });

    images.forEach((image, i) => {
      if (i > 0) doc.addPage("a4", orientationOf(image));
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      // Fit inside the margins without distorting it, centred
      const scale = Math.min(
        (pageWidth - 2 * PAGE_MARGIN) / image.width,
        (pageHeight - 2 * PAGE_MARGIN) / image.height,
      );
      const width = image.width * scale;
      const height = image.height * scale;
      doc.addImage(
        image,
        "png",
        (pageWidth - width) / 2,
        (pageHeight - height) / 2,
        width,
        height,
        "",
        "FAST",
      );
    });
    return doc;
  }
  
  export async function savePdf(imageUrls) {
    const multiPng = await generatePdf(imageUrls);
    const blobPdf = multiPng.output("blob");
    return blobPdf;
    
  }

